<template>
  <img v-if="theme === 'ANAUCO'" src="@/assets/images/logo/CyAnauco.png" alt="login" class="mx-auto">
  <img v-else                    src="@/assets/images/logo/CyA.png"      alt="login" class="mx-auto">
</template>
<script>
export default {
  data () {
    return {
      theme: process.env.VUE_APP_THEME
    }
  }
}
</script>